module.exports = __webpack_public_path__ + "static/images/MBA-1.e22988b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/MBA-1.png
// module id = PD9y
// module chunks = 8